
import { 
  Business, 
  Budget, 
  BillingManager,
  PaymentMethod, 
  DiscountCode, 
  BillingHistoryItem 
} from './types';

/**
 * Prepares billing data for the tab content by combining all required props
 */
export const prepareBillingData = (
  portfolioData: {
    billingData?: {
      activeBusinesses: Business[];
      pausedBusinesses: Business[];
      managedBudgets: Budget[];
      availableCredits: number;
      promotionalDiscount: number;
      billingManager: BillingManager | undefined;
      billingHistory: BillingHistoryItem[];
    }
  },
  totalCharge: number,
  paymentMethods: PaymentMethod[],
  discountCodes: DiscountCode[],
  selectedPaymentMethod: string,
  setSelectedPaymentMethod: (id: string) => void,
  handleAddPaymentMethod: () => void,
  handleAddPromoCode: () => void,
  handleMakePrimary: (methodId: string) => void,
  formatCurrency: (amount: number) => string,
  handleChangeBillingManager?: (userId: string) => void
) => {
  const billingData = portfolioData?.billingData || {
    activeBusinesses: [],
    pausedBusinesses: [],
    managedBudgets: [],
    availableCredits: 0,
    promotionalDiscount: 0,
    billingManager: undefined,
    billingHistory: []
  };

  return {
    activeBusinesses: billingData.activeBusinesses || [],
    pausedBusinesses: billingData.pausedBusinesses || [],
    managedBudgets: billingData.managedBudgets || [],
    availableCredits: billingData.availableCredits || 0,
    promotionalDiscount: billingData.promotionalDiscount || 0,
    billingManager: billingData.billingManager,
    billingHistory: billingData.billingHistory || [],
    paymentMethods,
    discountCodes,
    totalCharge,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    handleAddPaymentMethod,
    handleAddPromoCode,
    handleMakePrimary,
    handleChangeBillingManager,
    formatCurrency
  };
};
